import { inlineMarkdownToHtml } from '../domain/cards/parseCards';

export function CardContent({ text }: { text: string }) {
  return <div dangerouslySetInnerHTML={{ __html: inlineMarkdownToHtml(text) }} />;
}

export function figureSrc(path: string | null) {
  if (!path) return null;
  if (/^https?:\/\//.test(path) || path.startsWith('/')) return path;
  return `/${path.replace(/^\.\//, '')}`;
}
